import * as React from 'react';
import { Theme, makeStyles, useTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { Footer } from './Footer';
import { Header } from './Header';

const useStyles = makeStyles((_theme: Theme) => ({
  root: {
    display: 'flex',
    minHeight: '100vh',
    maxWidth: '1536px',
    margin: 'auto',
  },
  app: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: '1280px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  page: {
    flexGrow: 1,
  },
}));

interface LayoutProps {
  children: React.ReactNode | React.ReactNodeArray
}

export function Layout(props: LayoutProps) {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <div className={classes.root}>
      <CssBaseline />
      <div className={classes.app}>
        <Header />
        <div className={classes.page}>
          {props.children}
        </div>
        <Footer />
      </div>
    </div>
  );
}
